// @flow
import styled from 'styled-components';

export const StandardLayoutContainer = styled.div`
    margin: 0 auto;
    max-width: ${p => p.theme.layoutMaxWidth};
    overflow: hidden;
    padding: 0 1.5rem 1.5rem 1.5rem;
    width: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/widgets/layouts/standard/styles.js